
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SignIn from "./components/signin";

export default function App() {

  return (
    <BrowserRouter>
      <div className="pb-2">
        <Navbar />
        <Routes>
          <Route path="/" element={<HeroSection />} />
          <Route path="/signin" element={<SignIn />} />
          {/* Add other routes here */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}